import Swal from "sweetalert2";
import * as Cesium from 'cesium';
import { CollectionCategoryEnum } from 'Enums';
import withReactContent from "sweetalert2-react-content";
import { getLayerCollectionDetail } from '@/utils/helpers';

export const splitArrayIntoChunksOfLen = (arr, len) => {
  var chunks = [],
    i = 0,
    n = arr.length;
  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }
  return chunks;
};

export const turnOffLayers = (layerNamesToKeepOn = []) => {
  for (let layer in window.HDImagery) {
    if (layerNamesToKeepOn.includes(layer)) {
      let missionStyle = window.style.mosaic;
      let [_, collection] = getLayerCollectionDetail(layer);
      if (collection.category === CollectionCategoryEnum.terrain_mosaic || collection.category === CollectionCategoryEnum.terrain_tileset) missionStyle = window.style.terrain;
      window.HDImagery[layer][missionStyle].show = true;
    } else {
      turnOffLayer(layer);
    }
  }
}

export const turnOffLayer = (layer) => {
  for (let styleOrUUID in window.HDImagery[layer]) {
    if (['rgb', 'nir', 'greyscale', 'hillshade', 'schwarzwald'].includes(styleOrUUID)) {
      window.HDImagery[layer][styleOrUUID].show = false;
      window.HDImagery[layer][styleOrUUID].splitDirection = Cesium.SplitDirection.NONE;
    } else {
      for (let style in window.HDImagery[layer][styleOrUUID]) {
        window.HDImagery[layer][styleOrUUID][style].show = false;
        window.HDImagery[layer][styleOrUUID][style].splitDirection = Cesium.SplitDirection.NONE;
      }
    }
  }
}

export const showLayer = (layer, uuid, style, place) => {
  if (uuid === null) {
    window.HDImagery[layer][style].show = true;
    window.HDImagery[layer][style].splitDirection = place;
  } else {
    window.HDImagery[layer][uuid][style].show = true;
    window.HDImagery[layer][uuid][style].splitDirection = place;
  }
}

export const showAlert = (type, message) => {
  const allowed_types = ["error", "success", "info"];
  if (!allowed_types.includes(type)) throw new Error("ValueException: Invalid alert type");
  
  withReactContent(Swal).fire({
    icon: type.toLowerCase(),
    title: type.charAt(0).toUpperCase() + type.slice(1).toLowerCase(),
    html: message,
  });
}